import { createFeatureSelector, createSelector } from "@ngrx/store";
import {  IAsyncData, IAvailability, ITeam } from "@signal/asp-data-commons";
import { FeatureKeys } from "../app.reducer";
import { ScheduleDashboardState } from "./schedule-dashboard.reducer";



export const selectScheduleDashboardFeature = createFeatureSelector<ScheduleDashboardState>(FeatureKeys.SCHEDULE_DASHBOARD);

export const selectScheduleDashboardSlot = createSelector(
    selectScheduleDashboardFeature,
    (state: ScheduleDashboardState, props: { department: string }) => state.department.toLowerCase() === props.department.toLowerCase() ? state.slotAvailability : {} as IAvailability
);

export const selectScheduleDashboardAppointmentsForDay = createSelector(
    selectScheduleDashboardFeature,
    (state: ScheduleDashboardState, props: { department: string}) => state.appointmentLoaded && state.department.toLowerCase() === props.department.toLowerCase() ? state.appointmentSummary[0]?.appointments : [] 
);

export const selectScheduleDashboardAppointmentsForWeek = createSelector(
    selectScheduleDashboardFeature,
    (state: ScheduleDashboardState, props: { department: string}) => state.appointmentLoaded && state.department.toLowerCase() === props.department.toLowerCase() ? state.appointmentSummary : [] 
);
export const selectScheduleDashboardLoading = createSelector(
    selectScheduleDashboardFeature,
    (state: ScheduleDashboardState) =>  state.appointmentLoaded
);

export const selectScheduleDashboardSlotLoading = createSelector(
    selectScheduleDashboardFeature,
    (state: ScheduleDashboardState) =>  state.availabilityLoaded
);

export const selectScheduleDashboardDetails = createSelector(
    selectScheduleDashboardFeature,
    (state: ScheduleDashboardState) => state.dashboardDetails
)

